import { render, staticRenderFns } from "./DealBlock.vue?vue&type=template&id=76a96076&scoped=true"
import script from "./DealBlock.vue?vue&type=script&lang=js"
export * from "./DealBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a96076",
  null
  
)

export default component.exports